import styled from 'styled-components'

const StyledHeaderContainer = styled.header`
  padding: 0 !important;
  margin-bottom: 0 !important;
  min-height: 0 !important;
  .header-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    background-color: #FFF;
    padding: 8px 24px 0px 24px !important;
    width: 100%;
    box-sizing: border-box;
  }
`

const StyledTimeContainer = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: fit-content;
  
  h3 {
    color: ${ ({ theme }) => theme.colors.primary };
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 20px;
    margin: 0;
  }

  .wheelpicker-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;

    .time-flag {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      > button {
        font-size: 14px;
        width: 170px;

        &:first-of-type {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
        &:last-of-type {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }
    }

    .hour {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
  }

  .spinner-container {
    display: flex;
    justify-content: center;
  }

  .availabilities-container {
    padding: 8px 0px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 20px;
    overflow: auto;

    .availability-option {
      display: flex;
      flex-direction: row;
      border-radius: 5px;
      border: 1px solid ${ ({ theme }) => theme.colors.greyMedium};
      padding: 8px;
      justify-content: space-between;
      align-items: center;
      cursor: pointer;

      .time-container { 
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
      }

      .state-container {
        color: ${ ({ theme }) => theme.colors.greyMedium};
      }

      img {
        width: 20px;
        height: 20px;
      }
    }

    .selected {
      background-color: ${ ({ theme }) => theme.colors.accentLight};
      font-weight: 600;
    }

    .disabled {
      border: 1px solid ${ ({ theme }) => theme.colors.red};
      pointer-events: none;
      cursor: default;
    }
  }
    
  .no-availabilities {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    color: ${ ({ theme }) => theme.colors.greyDark};
    padding: 32px 20px;

    img {
      width: 184px;
      max-width: 100%;
      height: auto;
      margin-bottom: 10px;
    }

    span {
      font-size: 18px;
      font-weight: 500;
      text-align: center;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
    }
  }

  @media screen and (max-width: 768px) {
    display: block;
    flex-direction: row;
    justify-content: center;

    h3 {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .wheelpicker-container {
      justify-content: flex-start;
    }

    .availabilities-container {
      grid-template-columns: 1fr;
    }
  }

  @media screen and (min-width: 1280px) {
    .availabilities-container.iframe {
      grid-template-columns: repeat(3, 1fr);
    }
  }
`

const StyledSeatsContainer = styled.section`
  padding: 4px 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  background-color: ${ ({ theme }) => theme.colors.almostWhite};
  border-radius: 10px;
  
  div {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 16px;
    
    .seat-container {
      display: flex;
      flex-direction: row;
      gap: 4px;
      width: max-content;

      img {
        width: 22px;
        height: 22px;
      }

      p {
        margin: 0;
      }
    }
  }

  button {
    width: 180px;
  }

  @media screen and (max-width: 768px) {
    padding: 8px 16px;
    width: fit-content;

    button {
      width: 100px;
    }
  }
`


const StyledMapContainer = styled.section`
  flex: 1;
  min-height: 150px;
  margin-top: 16px;
  margin-bottom: 24px;
  position: relative;
  
  .map-slot {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .map {
    height: 100%;
  }
`

const StyledStopsSummaryContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  font-size: medium;
  font-weight: bold;

  > div {
    width: 72px;
  }
  @media screen and (max-width: 768px){
    label:first-child {
      text-align: end;
    }
  }
`

const StyledWeekdaysPickerContainer = styled.section`
  padding: 0;
  margin-top: 16px;

  .swiper-container {
    width: 100%;
  }

  .swiper-wrapper {
    display: flex;
    margin: 4px 0 8px;
    height: auto;
  }

  .weekday-card {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    width: var(--weekday-card-width, 90px) !important;
    margin-right: 16px;
    border: 1px solid ${ ({theme}) => theme.colors.greyLight };
    padding: 8px 16px;
    justify-content: 'space-evenly';
    background-color: ${ ({theme}) => theme.colors.white };
    cursor: pointer;
    box-sizing: border-box;

    .weekday, .day-month {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    span {
      cursor: pointer;
    }

    &.selected {
      border-color: ${ ({theme}) => theme.colors.greenRadio };
      background-color: ${ ({theme}) => theme.colors.lightGreen };
      .weekday {
        font-weight: bold;
      }
    }
  }

  .more-dates-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    * {
      cursor: pointer;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 8px 0px;
    margin-top: 0;

    .weekday-card {
      width: var(--weekday-card-width-mobile, 80px) !important;
    }
  }
`

export { StyledHeaderContainer, StyledSeatsContainer, StyledTimeContainer, StyledMapContainer, StyledStopsSummaryContainer, StyledWeekdaysPickerContainer }

